<template>
  <div>
    <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!edit || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="14" :md="14">
            <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]" key="nome">
              <el-input v-model="dados.nome" maxlength="191" v-on:blur="formatUpper('nome')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="5" :md="5">
            <el-form-item label="Modalidade" prop="modalidade" key="modalidade">
              <el-select v-model="dados.modalidade" clearable>
                <el-option label="CRECHE" value="creche"></el-option>
                <el-option label="PRÉ-ESCOLA" value="pre"></el-option>
                <el-option label="FUNDAMENTAL" value="fundamental"></el-option>
                <el-option label="EJA" value="eja"></el-option>
                <el-option label="INTEGRAL" value="integral"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="5" :md="5">
            <el-form-item label="Categoria" prop="categoria" key="categoria">
              <el-select v-model="dados.categoria" clearable>
                <el-option label="ENTRADA" value="entrada"></el-option>
                <el-option label="PRATO PRINCIPAL" value="prato_principal"></el-option>
                <el-option label="SOBREMESA" value="sobremesa"></el-option>
                <el-option label="BEBIDA" value="bebida"></el-option>
                <el-option label="LANCHE" value="lanche"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Rendimento (porções)" prop="rendimento_porcoes" key="rendimento_porcoes">
              <el-input v-model="dados.rendimento_porcoes" maxlength="6"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Tempo de preparo (min)" prop="tempo_preparo_min" key="tempo_preparo_min">
              <el-input v-model="dados.tempo_preparo_min" maxlength="6"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item label="Descrição" prop="descricao" key="descricao">
              <el-input type="textarea" :rows="3" v-model="dados.descricao"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item label="Modo de preparo" prop="modo_preparo" key="modo_preparo">
              <el-input type="textarea" :rows="4" v-model="dados.modo_preparo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <c-panel title="Ingredientes" titleIcon="fas fa-leaf">
          <el-row :gutter="10" class="u-mb-10">
            <el-col :xs="24" class="u-text-right">
              <el-button type="primary" plain icon="el-icon-plus" @click="addIng">ADICIONAR INGREDIENTE</el-button>
            </el-col>
          </el-row>
          <div class="container-table">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Alimento</th>
                  <th style="width: 140px;">Quantidade</th>
                  <th style="width: 120px;" class="u-text-center">Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(ing, idx) in ingredientes" :key="idx">
                  <td>
                    <el-select v-model="ing.alimento_id" placeholder="pesquisar" filterable remote clearable :remote-method="(q) => searchAlimento(q, idx)" :loading="ing.loadingAlimento">
                      <el-option v-for="a in ing.alimentos" :key="a.id" :label="a.nome" :value="a.id"></el-option>
                    </el-select>
                  </td>
                  <td><el-input v-model="ing.quantidade" maxlength="20"></el-input></td>
                  <td class="u-text-center">
                    <el-button v-if="edit && ing.id" @click="saveIng(ing)" type="info" icon="el-icon-check" size="mini" plain title="Salvar"></el-button>
                    <el-button @click="removeIng(ing, idx)" type="danger" icon="el-icon-delete" size="mini" plain title="Remover"></el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-panel>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-receita" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  components: {
    cPanel: () => import('@/shared/c-panel/c-panel.vue')
  },
  data: () => ({
    edit: false,
    dados: { id: '', nome: '', descricao: '', modalidade: '', categoria: '', modo_preparo: '', rendimento_porcoes: '', tempo_preparo_min: '' },
    ingredientes: []
  }),
  methods: {
    async getById (id) {
      const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/receita/getById/` + id, this.$store.getters.getHeaderAuth)
      this.dados = JSON.parse(JSON.stringify(res.data.receita))
      this.ingredientes = (res.data.ingredientes || []).map(i => {
        const row = Object.assign({}, i, { alimentos: [], loadingAlimento: false })
        if (i.alimento) row.alimentos = [{ id: i.alimento.id, nome: i.alimento.nome }]
        return row
      })
    },
    addIng () {
      this.ingredientes.push({ id: '', receita_id: '', alimento_id: '', quantidade: '', alimentos: [], loadingAlimento: false })
    },
    searchAlimento (query, idx) {
      if (!query || query.length < 2) { this.ingredientes[idx].alimentos = []; return }
      this.ingredientes[idx].loadingAlimento = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/alimento/searchByNome`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.ingredientes[idx].alimentos = JSON.parse(JSON.stringify(res.data)); this.ingredientes[idx].loadingAlimento = false })
        .catch(e => { this.ingredientes[idx].loadingAlimento = false; this.$store.commit('throwException', e) })
    },
    async removeIng (ing, idx) {
      if (this.edit && ing.id) {
        await this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/merenda/ingrediente/delete/` + ing.id, this.$store.getters.getHeaderAuth)
      }
      this.ingredientes.splice(idx, 1)
    },
    async saveIng (ing) {
      const payload = Object.assign({}, ing, { receita_id: this.dados.id })
      if (ing.id) {
        await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/ingrediente/update/` + ing.id, payload, this.$store.getters.getHeaderAuth)
      } else {
        const res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/ingrediente/store`, payload, this.$store.getters.getHeaderAuth)
        ing.id = res.data.id
      }
      window.eventBus.$emit('alert', { msg: 'Ingrediente salvo.', type: 'success' })
    },
    onSubmit () {
      document.getElementById("btn-receita").focus()
      this.$refs.dados.validate(async (valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        window.eventBus.$emit('loading', true)
        try {
          if (this.edit) {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/receita/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth)
            for (const ing of this.ingredientes) {
              if (!ing.id && ing.alimento_id && ing.quantidade) {
                await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/ingrediente/store`, Object.assign({}, ing, { receita_id: this.dados.id }), this.$store.getters.getHeaderAuth)
              }
            }
          } else {
            const payload = Object.assign({}, this.dados, { ingredientes: this.ingredientes.map(i => ({ alimento_id: i.alimento_id, quantidade: i.quantidade })) })
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/receita/store`, payload, this.$store.getters.getHeaderAuth)
          }
          window.eventBus.$emit('loading', false)
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.$emit('onSubmitReceita')
        } catch (e) {
          window.eventBus.$emit('loading', false)
          this.$store.commit('throwException', e)
        }
      })
    },
    formatUpper (field) {
      if (!this.dados[field]) return
      this.dados[field] = this.$removerAcentos(String(this.dados[field]).toUpperCase())
    }
  },
  watch: {
    paramId: {
      immediate: true,
      async handler (value) {
        if (value) {
          this.edit = true
          await this.getById(value)
        } else if (!this.ingredientes.length) {
          this.addIng()
        }
      }
    }
  }
}
</script>

